import React, { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  hoverable?: boolean;
}

const Card: React.FC<CardProps> = ({ 
  children, 
  className = '', 
  hoverable = false 
}) => {
  return (
    <div 
      className={`
        surface-card overflow-hidden
        ${hoverable ? 'surface-card-hover' : ''}
        ${className}
      `}
    >
      {children}
    </div>
  );
};

export default Card;